<template>
  <div style="height: 100%;">
    <div>
      <Header />
      <div class="plolicy-top-box width1200 projectbox">
        <div class="search-box">
          <!-- <select>
                  <option>北京</option>
                  <option>上海</option>
                  <option>深圳</option>
                </select> -->
          <div class="search-input-box">
            <input type="type" placeholder="请输入搜索内容" name="" v-model="searchkey"><span class="button" @click="cliSearch">搜索</span>

          </div>
        </div>

        <div class="policy-main">
          <div class="policy-top-tab">
            <!-- tab nav -->
            <ViewTabList />
            <!-- tab nav -->

            <!-- 筛查条件-移动端 -->
            <SearchCondition @activeItem="onActiveItem" @onselected="onConditionSelected" :items="initSearchCondition"
              :selectedKeys="selectedKeys" />
            <!-- 筛查条件-移动端 -->
          </div>

          <div class="main-container">
            <!-- 筛查条件pc -->
            <div class="screening-box main-container-left">
              <!-- <div class="all-class">
                <p class="p1">所有分类</p>
                <p class="p2">搜索结果：<span>{{count}}</span>个项目</p>
              </div> -->
              <div class="screen-items">
                <div class="right-text">
                  <div style="width: 150px;">
                    <p>项目类型 ：</p>
                  </div>
                  <div>
                    <a href="javascript:;" :class="selptype==index?'active':''" @click="selectPtype(index)" v-for="(item,index) in ptypes">{{item}}</a>
                  </div>
                </div>
              </div>
              <div class="screen-items" v-if="projecttype==1">
                <div class="right-text">
                  <div style="width: 150px;">
                    <p>服务类型 ：</p>
                  </div>
                  <div>
                    <a href="javascript:;" :class="serviceType==index?'active':''" @click="selectService(index)" v-for="(item,index) in services">{{item}}</a>
                  </div>
                  <!-- <span class="more-btn">更多<img src="../assets/main/bottom-arrow.png" alt=""></span> -->
                </div>
              </div>
              <div class="screen-items">
                <div class="right-text height-auto">
                  <div style="width: 150px;">
                    <p>专业领域 ：</p>
                  </div>
                  <div>
                    <a href="javascript:;" :class="seltpys==index?'active':''" v-for="(item,index) in projecttypes"
                      @click="selectprojecttypes(index)">{{item}}</a>
                  </div>
                  <!-- <span class="more-btn">全部区域<img src="../assets/main/bottom-arrow.png" alt=""></span> -->
                </div>
              </div>
              <div class="screen-items">
                <div class="right-text height-auto">
                  <div style="width: 150px;">
                    <p>细分领域 ：</p>
                  </div>
                  <div>
                    <a href="javascript:;" :class="seldtypes==index?'active':''" v-for="(item,index) in projectDetailTypes[seltpys]"
                      @click="selectprojectDetailTypes(index)">{{item}}</a>
                  </div>
                  <!-- <span class="more-btn">全部区域<img src="../assets/main/bottom-arrow.png" alt=""></span> -->
                </div>
              </div>
            </div>
            <!-- 筛查条件pc -->
            <div class="main-container-right main-container-right-pc">
              <!-- 项目列表 publishProject-->
              <!-- <div class="project-list-box">
                <div @click="publishProject" class="consulting">发 布 需 求</div>
                <ul v-if="!hidelist" class="project-list">
                  <li v-for="(item,index) in resaultlist" :key="index" @click.prevent="detail(item)">
                    <a href="javascript:;">
                      <div class="project-img">
                        <img :src="item.imgs">
                      </div>
                      <p class="pp1">{{item.nonamount?'价格面议':'¥'+item.amount_upper}} <span>{{item.project_type?'产品':'服务'}}</span></p>
                      <p class="pp2">{{item.title}}</p>
                      <p class="pp3"><span>北京科创技术有限公</span> <a href="javascript:;" @click.stop="sigup(item.pid)">快速报名</a></p>
                    </a>
                  </li>
                </ul>
              </div> -->
              <div class="policy-list policy-list-service">
                <div @click="publishProject" class="consulting">发 布 需 求</div>
                <ul v-if="!hidelist">
                  <li class="policy-li" v-for="(item,index) in resaultlist" :key="index" @click="detail(item)">
                    <div class="left-txt">
                      <div class="flex">
                        <div class="img1 margin-left-sm" style="width: 150px; height: 150px;">
                          <img :src="item.imgs">
                        </div>

                        <div class="service-title margin-left-sm">
                          <div class="flex align-center justify-between">
                            <h3>{{item.title}}</h3>
                            <div class="text-red">{{item.project_type?'产品':'服务'}}</div>
                          </div>
                          <p class="pp1">{{item.nonamount?'价格面议':'¥'+`${item.amount_lower}-${item.amount_upper}`}} </p>
                          <p class="pp2">发布时间:{{item.create_time}}</p>
                        </div>
                      </div>


                    </div>
                    <div class="talent-plan">
                      <a href="javascript:;">{{item.province}}</a>
                      <div class="bg-blue padding-tb-sm margin-lr-sm">
                        <div class="text-white text-center" @click.stop="sigup(item.pid)">快速报名</div>
                      </div>
                    </div>

                  </li>

                </ul>
              </div>
              <div class="paging-box">
                <el-pagination layout="prev, pager, next" :page-size="limit" :total="count" @current-change="pagechange"></el-pagination>
              </div>
              <!-- 项目列表 -->
            </div>
          </div>


        </div>
        <!-- <ProjectSigup :showDailog="showDailog" :pid="selectSigupId" v-on:dataChange="showHide"></ProjectSigup> -->
      </div>
      <Footer :isLogin="true" />
    </div>
  </div>
</template>

<script>
  import Header from '@/components/Header.vue';
  import Footer from '@/components/Footer.vue';
  import ViewTabList from '@/components/ViewTabList.vue';
  import {
    Pagination
  } from 'element-ui';
  import ProjectSigup from '../components/ProjectSigup.vue'
  import {
    addProject,
    modifyProject,
    searchproject,
    getProject,
    projectSingup,
    projectSingups,
    deleteMyProject,
    myprojectsignupelist,
    projectcomment,
  } from '@/api/project.js'
  import config from '@/config/index';
  import {
    getCacheUserInfo
  } from '@/utils/auth';

  import SearchCondition from '@/components/SearchCondition.vue';
  import {
    ProjectSearchCondition
  } from '@/const/ProjectSearchCondition.js'
  import SearchConditionMixin from '@/mixins/SearchCondition.mixin.js'



  export default {
    mixins: [SearchConditionMixin],
    name: 'Project',
    components: {
      Header,
      Footer,
      ViewTabList,
      [Pagination.name]: Pagination,
      ProjectSigup,
      SearchCondition,
    },
    watch: {
      $route(to, from) {}
    },
    data() {
      return {
        hidelist: false,
        initSearchCondition: ProjectSearchCondition,
        resaultlist: [],
        page: 1,
        limit: 12,
        count: 0,
        projecttype: 9,
        industrycategory: '',
        projectcategory: '',
        searchkey: '',
        showDailog: false,
        selectSigupId: 0,

        ptypes: ['全部', '产品型', '服务型'],
        selptype: 0,

        services: ['全部', '咨询规划', '专业设计', '工程建设', '人力外包', '监理审计', '创新场景', '金融服务'],
        serviceType: 0,

        projecttypes: ['全部', '智慧应用', '数据智能', '生态系统', '可信安全', '新型网络', '智慧专区', '数字上云', '金融服务'],
        seltpys: 0,
        projectDetailTypes: [
          ['全部'],
          ['智慧政务应用', '智慧城市应用', '智慧民生应用', '智慧产业应用', '传统基础设施赋能', '中小企业赋能'],
          ['数据中心', '云边端', '大数据平台', '人工智能', '区块链服务平台', '数据交易'],
          ['产业园区生态', '共性支撑软件', '科学仪器', '中试服务生态', '共享开源平台'],
          ['基础安全能力', '行业应用安全', '新型安全服务平台'],
          ['5G网络', '千兆固网', '卫星互联网', '车联网', '工业互联网', '政务专网'],
          ['智慧住建', '智慧园区', '智慧社区', '智慧出行', '智慧家居', '智慧健康', '智慧教育', '智慧政务'],
          ['云计算', '域名', '内容安全', '网络', '存储与CDN', 'AI开放服务', '数据库', '其它产品服务提供商'],
          ['银行服务', '风险投资', '投资基金', '融资担保', '债券股票', '民间借贷']
        ],
        seldtypes: 0
      }
    },
    mounted() {
      if (this.$route.query.keyword) {
        this.searchkey = this.$route.query.keyword
      }
      this.queryProject()
    },

    methods: {
      cliSearch() {
        this.queryProject()
      },
      selectprojecttypes(index) {
        this.seltpys = index
        if (index == 0) {
          this.projectcategory = ''
          this.seldtypes = 0
          this.queryProject()
        } else {
          this.seldtypes = -1
        }
      },
      selectprojectDetailTypes(index) {
        this.seldtypes = index
        this.projectcategory = this.projectDetailTypes[this.seltpys][index]
        this.queryProject()
      },
      selectPtype(index) {
        this.selptype = index
        if (index == 0) {
          this.projecttype = 9
        } else {
          this.projecttype = this.selptype - 1
        }
        this.queryProject()
      },
      selectService(index) {
        this.serviceType = index
        if (index == 0) {
          this.industrycategory = ''
        } else {
          this.industrycategory = this.services[index]
        }
        console.log(this.industrycategory)
        this.queryProject()
      },
      showHide(param) {
        console.log("handleClose")
        this.showDailog = param.show
      },
      // sigup(pid) {
      //   this.selectSigupId = pid
      //   this.showDailog = true
      //   console.log(pid)
      // },
      publishProject() {
        this.$router.push('project-publish?type=project');
      },
      pagechange(page) {
        this.page = page
        this.queryProject()
      },
      queryProject() {
        const projecttype = this.projecttype
        const industrycategory = this.industrycategory
        const projectcategory = this.projectcategory
        const page = this.page
        const limit = this.limit
        const searchkey = this.searchkey
        this.$http.get(searchproject(), {
          searchkey,
          projecttype,
          industrycategory,
          projectcategory,
          page,
          limit
        }).then(res => {
          console.log(res);
          if (res.code === 1) {
            // this.$router.push('org');
            this.resaultlist.splice(0, this.resaultlist.length)
            this.count = res.data.count
            var list = res.data.list
            var item;
            for (var i = 0; i < list.length; i++) {
              item = list[i]
              if (item.imgs) {
                var img = JSON.parse(item.imgs)[0]
                //console(item.imgs,img)
                item.imgs = `${config.HOST_IMG}${img}`
              }
              this.resaultlist.push(item)
            }
          } else {
            this.$message.warning(res.msg);
          }
        });

      },
      detail(item) {
        if (item.project_type === 0) {
          this.$router.push('/detail/service?projectid=' + item.pid)
        } else {
          this.$router.push('/detail/product?projectid=' + item.pid)
        }
      },
      toogleListShow(hide) {
        this.hidelist = hide
        if (hide == false) {
          console.log("this.selectedKeys-->", this.selectedKeys)

          this.selectedKeys.forEach(item => {
            if (item.boxKey === "项目类型") {
              if (item.key === "item-0-产品型") {
                this.projecttype = 0
                this.industryCategory = ''
              } else if (item.key === "item-0-全部") {
                this.projecttype = 9
                this.industryCategory = ''
              } else {
                this.projecttype = 1
                this.industryCategory = item.item.name
              }
            } else {
              if (item.item.name === "全部") {
                this.projectcategory = ""
              } else {
                this.projectcategory = item.item.name
              }
            }
          })
          this.queryProject()
          // console.log("this.governmenttype->",this.governmenttype)
          // console.log("this.policytype>",this.policytype)
          // this.queryProject()
        }
      },
      sigup(pid) {
        let userinfo = getCacheUserInfo()
        let params = {
          pid: pid, //账号id
          uid: userinfo.uid, //用户id
          contacts: userinfo.name, //联系人
          mobile: userinfo.account, //手机号
          content: "无", //留言内容
        }

        this.$http.post(projectSingup(),
          params
        ).then((res) => {
          console.log(res);
          if (res.code === 1) {
            this.$message.success("报名成功");
          }
        });
      },
    }
  }
</script>

<style scoped>
  @import url(./Policy.css);
  @import url(./project.css);
  @import url(../mainui.css);
  .paging-box {
    text-align: center;
    /* margin: 30px 0 30px 140px; */
    overflow: hidden;
  }

  @media screen and (max-width: 850px) {
    .projectbox {
      width: 100%;
    }
  }
</style>
